// extracted by mini-css-extract-plugin
module.exports = {"container":"_2PBfXgdPN81USfAZg9Cqp7","image":"Aa3Uoscl2Faaa4uBbUegZ"};